const Resources = {

    table_headers: [
        { 
          text: 'Description',
          align: 'start',
          value: 'comment'
        },
        { 
          text: 'Service request',
          value: 'service_request'
        },
        {   
            text: 'Associate',
            value: 'associate'
        },
        {   
            text: 'Date',
            value: 'date'
        },
    ],

    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Assignments',
            href:   '/assignment-daily-assignments',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Service Requests',
            href:   '/assignment-service-request',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Associate Service Requests',
            href:   '#',
            arrow:  "<span class='slash'>/</span>",
        },
    ],

}

export default Resources;